import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {useDefaultErrorHandler} from "./ErrorHooks";

export const useMakePageRequest = () => {
    const [pendingRequest, setPendingRequest] = useState(null);
    const displayTimeout = useSelector(state => state.loginState.displayTimeout);
    const defaultErrorHandler = useDefaultErrorHandler();

    useEffect(() => {
        if(!displayTimeout && pendingRequest) {
            let {logic, success, failure} = pendingRequest;
            setPendingRequest(null);

            void makePageRequest(logic, success, failure);
        }
    }, [displayTimeout]);

    const makePageRequest = (logic, success = null, failure = null) => {
        return new Promise(async (resolve, reject) => {
            // wrap our promise handlers so
            // so that they also call this promise's
            // resolve / reject parameters
            let wrappedSuccess = (x) => {
                success?.(x);
                resolve(x);
            };
            let wrappedFailure = (x) => {
                if (failure) {
                    failure?.(x);
                } else {
                    defaultErrorHandler(x);
                }
                reject(x);
            };
            
            try {
                const x = typeof logic === 'function' ? (await logic()) : null;
                if (Array.isArray(x) || Number(x?.status) === 200) {
                    wrappedSuccess?.(x);
                }
            } catch (x) {
                if (x.data && x.data.sessionTimeout) {
                    // store our request so we can
                    // reinitiate it after re-login
                    setPendingRequest({
                        logic: logic,
                        success: wrappedSuccess,
                        failure: wrappedFailure
                    });
                } else {
                    wrappedFailure?.(x);
                }
            }
        });
    };
    //return promise that'll resolve or reject with our custom logic. Also still honor passed functions in argument signature.
    return makePageRequest;
};
